import { useCallback, useEffect, useMemo, useState } from "react";
import { genericGet } from "services/services.general";
import { getFormattedOptions } from "utility/helpers";

const useSectors = () => {
  const [sectors, setSectors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    genericGet({
      url: "course/sectors",
      callback: (data) => {
        setSectors(data);
        setIsLoading(false);
      },
    });
  }, []);

  const options = useMemo(() => {
    return getFormattedOptions("name", sectors);
  }, [sectors]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: sectors,
    options,
    isLoading,
    refetch,
  };
};

export default useSectors;
